import { ApplicationController } from "../application_controller";
import Tabulator from "tabulator-tables";

export default class extends ApplicationController {
    static targets = ["table", "train_number", "from_cities", "to_cities", "train_names"]

    connect() {
			if (this.hasTableTarget) {
				const content_url = this.data.get("table-load-url");
				this.createTable(content_url);
			}
    }

    filterTable() {
			this.setFilterToTable();
    }

    setFilterToTable() {
			let filters = []
			
			if (this.hasTrain_numberTarget) {
				filters.push({
					field: "train_number",
					type: "=",
					value: this.train_numberTarget.value
				})
			}

			if (this.hasTrain_namesTarget) {
				const selectedValues = this.train_namesTarget.choices.getValue(true)
				if (selectedValues && selectedValues.length > 0) {
					filters.push({
						field: "train_names",
						type: "in",
						value: selectedValues
					})
				}
			}        

			if (this.hasFrom_citiesTarget) {
				filters.push({
					field: "from_cities_ids",
					type: "=",
					value: this.from_citiesTarget.choices.getValue(true)
				})
			}

			if (this.hasTo_citiesTarget) {
				filters.push({
					field: "to_cities_ids",
					type: "=",
					value: this.to_citiesTarget.choices.getValue(true)
				})
			}

			if (filters.length) {
				this.tableTarget.tabulator.setFilter(filters);
			}
    }

    // Create main table
    async createTable(url) {
			const columns = this.data.get("table-columns");
			const table_target = this.tableTarget;
			const default_props = super.tabulatorDefaultProps
			const height = document.getElementById('content').clientHeight;
			const table_id = this.data.get("table-id");

			let table_props = {
				layout: "fitDataTable",
				virtualDomBuffer: 4000,
				index: "id",
				height: (height - 200) + "px",
				persistenceID: table_id,
				movableColumns: true,
				// columns
				columns: JSON.parse(columns),
				// sort
				headerSort: false,
				// pagination
				paginationDataSent: {
						"size": "per_page"
				},
				paginationSize: 25,
				// Ajax
				ajaxURL: url,
				ajaxSorting: true,
				ajaxLoader: true,
				ajaxFiltering: true,
				ajaxLoaderLoading: "<div class='loader' > Loading...</div> ",
				ajaxProgressiveLoad: "scroll"
			}

			table_props = Object.assign(default_props, table_props);
			// create table
			table_target.tabulator = new Tabulator(table_target, table_props);
			table_target.tabulator.setLocale(super.appLocale);
    }
}